export { default } from "./GenerationGeniusLogo.svg";
